interface IFidoKey {
    uniqueIdentifier: string;
}

class SiteLabelFido
    extends SiteLabel<IFidoKey, ISiteLabelConfig> {

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel,  element: HTMLElement) {
        super(card, model, modelData, element);

        console.log(model);
    }
    
    getInput() {
        return null;
    }

    defaultConfig(): ISiteLabelConfig {
        return {
            popout: 'inline',
            scroll: "top"
        }
    }

    async register(uniqueIdentifier: string) {
        // -- Request Fido
        let fidoRequest = await new QueryRequest('Api/FidoRegisterRequest', {
            contentType: 'json',
            method: 'post',
            data: JSON.stringify({
                uniqueIdentifier: uniqueIdentifier
            })
        }).request();
        let fidoResponse = await fidoRequest.json();
        
        // Convert some properties
        fidoResponse.challenge = Fido.coerceToArrayBuffer(fidoResponse.challenge);
        fidoResponse.user.id = Fido.coerceToArrayBuffer(fidoResponse.user.id);
        fidoResponse.excludeCredentials = fidoResponse.excludeCredentials.map((c:any) => {
            c.id = Fido.coerceToArrayBuffer(c.id);
            return c;
        });
        if (fidoResponse.authenticatorSelection.authenticatorAttachment === null) 
            fidoResponse.authenticatorSelection.authenticatorAttachment = undefined;
        
        // -- Do credential create
        let newCredential : PublicKeyCredential;
        let newCredentialResponse : AuthenticatorAttestationResponse;
        try {
            newCredential = (await navigator.credentials.create({
                publicKey: fidoResponse
            }) as PublicKeyCredential) ?? throwExpression("No credentials fetched.");

            newCredentialResponse = newCredential.response as AuthenticatorAttestationResponse 
                ?? throwExpression("Wrong response.");
        } catch (e) {
            console.error(e);
            this.setValue({
                uniqueIdentifier: uniqueIdentifier
            });
            this.error();
            return;
        }
        
        // -- Register to server
        let registerData = {
            id: newCredential.id,
            rawId: Fido.coerceToBase64Url(new Uint8Array(newCredential.rawId)),
            type: newCredential.type,
            extensions: newCredential.getClientExtensionResults(),
            response: {
                attestationObject: Fido.coerceToBase64Url(new Uint8Array(newCredentialResponse.attestationObject)),
                clientDataJson: Fido.coerceToBase64Url(new Uint8Array(newCredentialResponse.clientDataJSON))
            }
        };

        let registerRequest = await new QueryRequest('Api/FidoRegister', {
            contentType: 'json',
            method: 'post',
            data: JSON.stringify({
                uniqueIdentifier: uniqueIdentifier,
                response: registerData
            })
        }).request();
        switch(registerRequest.status)
        {
            case 200:
                this.setValue(await registerRequest.json() as IFidoKey);
                this.success();
                break;
            default:
                this.error();
                break;
        }
    }

    error() {
        this.addClass("error")
            .removeClass("ok");
    }
    success() {
        this.addClass("ok")
            .removeClass("error");
    }


    makeActive() {
        super.makeActive();

        var model = this.getModelValue();
        if (model == null)
            throw "No modelvalue recieved";

        this.register(model.uniqueIdentifier);

        return true;
    }

    getValue() {
        var model = this.getModelValue();
        if (model == null)
            throw "No modelvalue recieved";
        
        return model;
    }

    async remove(removeInner = true) {
        await super.remove(removeInner);
    }
}